// Ubicación en el repo: src/components/FrequencyTable.jsx
// Tabla OD/OI por frecuencia — igual estructura que freqInputsHTML() del
// prototipo (línea ~1758): una fila por frecuencia, columnas OD/OI con
// inputs numéricos en dB. Se reutiliza para vía aérea, vía ósea y LDL
// dentro de ExamFormModal.
//
// `min`/`max`/`step` (migración 0053, 16-sep-2026): 0 a 120 dB, de 5 en 5 —
// validación real (además de esto) vive en exams.js/invalidFreqEntries(),
// llamada antes de guardar en ExamFormModal — esto es solo la comodidad de
// las flechitas del navegador y el aviso nativo si se tipea a mano un valor
// fuera de rango.
//
// `odMasked`/`oiMasked`/`onToggleMask` (mismo pedido, enmascaramiento):
// opcionales — si no se pasan, no aparece ninguna casilla (así LDL, que no
// tiene este concepto, sigue igual que antes sin tocar su llamado).
//
// `odNr`/`oiNr`/`onToggleNr` (migración 0056, 15-oct-2026, pedido de
// Nicolás): casilla "SR" (sin respuesta / sin umbral), también opcional y
// independiente de la de enmascaramiento — se pueden marcar las dos a la
// vez (símbolo de sin respuesta enmascarado). El dB cargado en esa fila es
// el nivel máximo evaluado, donde se dibuja el símbolo con su flecha.
export default function FrequencyTable({
  label,
  freqs,
  odValues,
  oiValues,
  onChange,
  odMasked,
  oiMasked,
  onToggleMask,
  odNr,
  oiNr,
  onToggleNr,
}) {
  const maskable = !!onToggleMask;
  const nrable = !!onToggleNr;

  function renderCell(ear, f, values, masked, nr) {
    return (
      <div className="freq-table__cell">
        <input
          type="number"
          min={0}
          max={120}
          step={5}
          value={values[f] ?? ''}
          placeholder="dB"
          onChange={(e) => onChange(ear, f, e.target.value)}
        />
        {maskable && (
          <label className="freq-table__mask" title="Enmascarado (vía contralateral)">
            <input
              type="checkbox"
              checked={!!masked?.[f]}
              onChange={(e) => onToggleMask(ear, f, e.target.checked)}
            />
            E
          </label>
        )}
        {nrable && (
          <label className="freq-table__mask" title="Sin respuesta (sin umbral) — el dB es el nivel máximo evaluado">
            <input
              type="checkbox"
              checked={!!nr?.[f]}
              onChange={(e) => onToggleNr(ear, f, e.target.checked)}
            />
            SR
          </label>
        )}
      </div>
    );
  }

  return (
    <table className="freq-table">
      <thead>
        <tr>
          <th>Frecuencia</th>
          <th className="freq-table__od">OD ({label})</th>
          <th className="freq-table__oi">OI ({label})</th>
        </tr>
      </thead>
      <tbody>
        {freqs.map((f) => (
          <tr key={f}>
            <td>{f} Hz</td>
            <td>{renderCell('od', f, odValues, odMasked, odNr)}</td>
            <td>{renderCell('oi', f, oiValues, oiMasked, oiNr)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
